// extracted by mini-css-extract-plugin
module.exports = {"item":"CompanyCardListWithJob_item__3n5gy","sending":"CompanyCardListWithJob_sending__2Fchh"};